<template>
    <div class="py-3">
        <div class="type_container">
            <div class="flex mt-1 gap-4 justify-start">
                <label for="recieverBusiness" class="radio-label">
                    <input class=" bg-primary-yellow text-secondary-yellow" name="recievertype" type="radio"
                        id="recieverBusiness" value="business" v-model="reciever.type" />
                    Business Customer
                    <span></span>
                </label>

                <label for="recieverPrivate" class="radio-label">
                    <input type="radio" v-model="reciever.type" value="private" id="recieverPrivate"
                        name="recievertype" />
                    Private Customer
                    <span></span>
                </label>
            </div>

            <div>
                <div class="pb-0 mt-3">
                    <base-checkbox v-model="useExistingReciever" label="Use Existing Receiver" />
                </div>
            </div>
        </div>


        <div class="flex flex-wrap justify-start">
            <div v-if="useExistingReciever" class="slice-option">
                <label class="label">Name</label>
                <el-select filterable v-model="reciever.nameSelect" placeholder="-- Select --">
                    <el-option v-for="location in deliveryLocations" :key="location?.contactName"
                        :label="location.contactName" :value="location.id">
                    </el-option>
                </el-select>
            </div>
            <div v-if="!useExistingReciever" class="slice-option">
                <label class="label">Name</label>
                <input type="text" class="input-mini" placeholder="--Enter--" v-model="reciever.name" />
            </div>
            <div v-if="reciever.type === 'business'" class="slice-option">
                <label class="label">Contact Person</label>
                <input type="text" class="input-mini" placeholder="--Enter--" v-model="reciever.contactName" />
            </div>
            <div class="slice-option">
                <label class="label">Email</label>
                <input type="text" class="input-mini" placeholder="--Enter--" v-model="reciever.email" />
                <span v-if="!isEmailValid && reciever.email != ''" class="mt-2 text-red-500 inline-block">Email is
                    invalid
                </span>
            </div>

            <div class="slice-option_phone">
                <div class="flex justify-between items-center">
                    <label class="label whitespace-no-wrap">Phone Number</label>
                    <div class="w-full flex mt-1 gap-4 justify-end">
                        <label for="mobilePhone" class="radio-label">
                            <input class=" bg-primary-yellow text-secondary-yellow" name="phone" type="radio"
                                id="mobilePhone" value="mobile" v-model="reciever.mobileNumberType" />
                            Mobile
                            <span></span>
                        </label>

                        <label for="fixedPhone" class="radio-label">
                            <input type="radio" v-model="reciever.mobileNumberType" value="fixed" id="fixedPhone"
                                name="phone" />
                            Fixed
                            <span></span>
                        </label>
                    </div>
                </div>
                <vue-tel-input v-model="reciever.mobile" class="phone_input_style"></vue-tel-input>
                <span v-if="isPhoneNumberInValid" class="mt-2 text-red-500 inline-block">Phone number is invalid</span>
            </div>

            <div class="slice-option_address">
                <div class="flex justify-between items-center">
                    <label class="label whitespace-no-wrap">Destination Address <abbr class="address_grey">(Unit, House
                            Number, Street, City, State)</abbr> </label>
                    <div class="w-full flex mt-1 gap-4 justify-end">
                        <label for="firstAddress" class="radio-label">
                            <input class=" bg-primary-yellow text-secondary-yellow" name="address" type="radio"
                                id="firstAddress" value="residential" v-model="reciever.customerType" />
                            Residential
                            <span></span>
                        </label>

                        <label for="lastAddress" class="radio-label">
                            <input type="radio" v-model="reciever.customerType" value="business" id="lastAddress"
                                name="address" />
                            Business
                            <span></span>
                        </label>
                    </div>
                </div>
                <!-- <auto-complete :customStyle="customStyle" :locationDetails="viewLocationDetails"
                    placeholder="Enter Address" :value="reciever.address.name" /> -->
                <input v-model="addressInput" type="text" class="input-mini" placeholder="--Enter--" />
                <span v-if="reciever.address?.name && addressInput != ''" class="google_pick_location">
                    <img src="/icons/location_icon.svg" class="image_loc" />
                    {{ selectedAddress ? selectedAddress.name : "" }}</span>
            </div>

            <div class="slice-option_picker">
                <div class="flex justify-between items-center flex-wrap w-full">
                    <label class="label">Preferred Delivery Time Range <span
                            class="opacity-50">(optional)</span></label>
                    <div class="flex  w-full justify-between items-center">
                        <!-- <div class="clock_box">
                            <img src="./icons//clock.svg"/>
                        </div> -->
                        <el-time-picker class="full_width full_width_sender mr-2 only_hour_picker"
                            placeholder="Start time" v-model="startTime" :disabled-seconds="true" format="hh:mm"
                            value-format="hh A" popper-class="only_hour_picker">
                        </el-time-picker>
                        <el-time-picker class="full_width full_width_sender" placeholder="End time" v-model="endTime"
                            popper-class="only_hour_picker" :disabled-seconds="true" format="hh:mm" value-format="hh A">
                        </el-time-picker>
                    </div>
                </div>
            </div>
        </div>


        <div class="w-full pb-10 mt-4 flex items-center">
            <hr class="w-full">
            <button @click="saveReciever" class="add_receiver_btn">
                <img v-if="!reciever.isEdit" src="./icons/addicon.svg" class="plus_img" />
                {{ reciever.isEdit ? 'Saved Changes' : 'Save & Add Another' }}</button>
        </div>
        <div class="overflow-x-auto">
            <div class="table_wrapper">
                <table class="custom-table responsive-table border-collapse">
                    <tbody class="p-4">
                        <tr v-for="(reciever, index) in savedReciever" :key="index + 'list_package'"
                            class="rounded-lg border-[1px] border-primary-palegrey">
                            <td class="align_top">
                                <span>
                                    <b class="opacity-50 uppercase font-semibold text-sm"> Name</b>
                                    <span class="block w-full opacity-50">{{ reciever.name }}</span>
                                </span>
                            </td>
                            <td class="align_top">
                                <span>
                                    <b class="opacity-50 uppercase font-semibold text-sm"> Contact Person</b>
                                    <span class="block w-full opacity-50">{{ reciever.contactName }}</span>
                                </span>
                            </td>
                            <td class="align_top">
                                <span>
                                    <b class="opacity-50 uppercase font-semibold text-sm"> Phone Number</b>
                                    <span class="block w-full opacity-50">{{ reciever.mobile }}</span>
                                </span>
                            </td>
                            <td class="align_top">
                                <span>
                                    <b class="opacity-50 uppercase font-semibold text-sm"> Email Address</b>
                                    <span class="block w-full opacity-50">{{ reciever.email }}</span>
                                </span>
                            </td>
                            <td class="align_top">
                                <span>
                                    <b class="opacity-50 uppercase font-semibold text-sm"> Destination Address</b>
                                    <span class="block w-full opacity-50">{{ reciever.address && reciever.address.name
                                        }}</span>
                                </span>
                            </td>
                            <td>
                                <div class="flex items-center justify-end">
                                    <span @click="editReciever(index)" class="icon mr-1"><img alt="imgs_icon"
                                            class="img_icon" src="./icons/editIcon.svg" /></span>
                                    <span @click="deleteReciever(index)" class="icon"><img alt="" class="img_icon_del"
                                            src="./icons/deleteIcon.svg" /></span>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment";

export default {
    name: 'Reciever_flow',
    computed: {
        canSend() {
            const { name, contactName, email, address, mobile } = this.reciever
            return (!this.isPhoneNumberInValid && this.isEmailValid && (name != "" || contactName != "") && email != "" && address?.lat != undefined && mobile != "")
        },
        isPhoneNumberInValid() {
            let trimTel = this.reciever.mobile.replace(/ /g, "");
            const phoneValid = (this.reciever.mobile != "" && trimTel?.length < 11) || (this.reciever.mobile != "" && trimTel?.length > 11)
            return this.reciever.mobile == undefined ? false : phoneValid;
        },
        isEmailValid() {
            const emailRegex =
                /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return this.reciever.email == undefined ? false : emailRegex.test(this.reciever.email);
        },
        customStyle() {
            return {
                width: '100%',
                padding: '7px 10px',
                borderRadius: '5px',
                border: '1px solid rgb(183 189 205)'
            }
        },
        payload() {
            return {
                userId: this.$store.getters.userId,
                type: "delivery",
            };
        },
    },
    data() {
        return {
            deliveryLocations: [],
            savedReciever: [],
            useExistingReciever: false,
            addressInput: "",
            selectedAddress: {},
            startTime: "",
            endTime: "",
            addressDebounce: null,
            reciever: {
                type: 'private',
                contactName: '',
                name: "",
                email: '',
                id: undefined,
                mobileNumberType: 'mobile',
                customerType: 'residential',
                address: {},
                mobile: '',
                isEdit: false,
                sendShippingUpdates: false,
                nameSelect: '',
                package: undefined,
                pickUpTime: [],
            }
        }
    },
    watch: {
        addressInput: {
            handler(val) {
                clearTimeout(this.addressDebounce); // 🧹 Clear previous timer
                if (val.trim().length > 3) {
                    // 🕒 Wait 500ms before calling getCloseLocation
                    this.addressDebounce = setTimeout(() => {
                        this.getCloseLocation(val);
                    }, 500);
                }
            },
            immediate: false,
        },
        "useExistingReciever"(val) {
            if (!val) {
                let userInfo = {
                    contactName: ``,
                    email: "",
                    mobile: "",
                    address: {
                        name: "",
                        lat: undefined,
                        lng: undefined,
                        state: ""
                    }
                }
                this.reciever = { ...this.reciever, ...userInfo }
            }
        },
        "reciever.nameSelect"() {
            let selectedLocation = this.deliveryLocations.find(location => location?.id === this.reciever?.nameSelect);
            let userInfo = {
                contactName: selectedLocation?.contactName,
                name: selectedLocation?.contactPerson ? selectedLocation?.contactPerson : "",
                email: selectedLocation?.email,
                mobile: selectedLocation?.mobile,
                address: {
                    name: selectedLocation.address?.name,
                    lat: selectedLocation.address?.lat,
                    lng: selectedLocation.address?.lng,
                    state: selectedLocation?.address?.state
                }
            }
            this.addressInput = selectedLocation?.address?.name || ""
            this.reciever = { ...this.reciever, ...userInfo }
        }
    },
    mounted() {
        this.getAllLocations();
        this.checkAutoloadInfo()
    },
    methods: {
        checkAutoloadInfo() {
            const quoteReciever = this.$store.getters.latestNewInitialShipping.consigneelocation
            if (quoteReciever?.id) {
                this.reciever.address = quoteReciever?.address;
                this.addressInput = quoteReciever?.address?.name;
            }
        },
        async getCloseLocation(val) {
            const res = await this.$_searchAddress({ query: val.trim() })
            this.selectedAddress = res.data.results[0];
            this.reciever.address = { ...res.data.results[0], name: this.addressInput };
        },
        resetReciever() {
            this.reciever = {
                type: 'private',
                contactName: '',
                name: "",
                email: '',
                mobileNumberType: 'mobile',
                addressType: 'residential',
                address: {},
                mobile: '',
                isEdit: false,
                id: undefined,
                sendShippingUpdates: false,
                nameSelect: '',
                package: undefined,
                pickUpTime: [],
            };
            this.addressInput = "";
            this.selectedAddress = {};
        },
        deleteReciever(index) {
            this.savedReciever.splice(index, 1);
        },
        editReciever(index) {
            this.useExistingReciever = false;
            this.reciever = this.savedReciever[index];
            this.reciever.isEdit = true;
            this.addressInput = this.reciever?.address?.name;
        },
        saveReciever() {
            if (!this.canSend) return

            let cloneSavedReciever = this.savedReciever;
            if (this.reciever.isEdit) {
                cloneSavedReciever[this.savedReciever.findIndex((reciever) => reciever.isEdit)] = { ...this.reciever, isEdit: false }
            } else {
                cloneSavedReciever.push(this.reciever);
            }
            this.savedReciever = cloneSavedReciever;
            this.resetReciever()
        },
        async getAllLocations() {
            try {
                const response = await this.$_getRecieverLocations(this.payload);
                this.deliveryLocations = response.data.data.locations;
            } catch (error) {
                this.handleError(error);
            }
        },
        saveRecieverTostore() {
            const { name, email, mobile, contactName } = this.reciever;
            if (!this.canSend && !this.reciever.address?.lat && this.$store.getters.getSavedNewRecievers.length < 1) {
                this.generateToast("Reciever address must be valid");
                return false
            }
            else if (!this.canSend && this.$store.getters.getSavedNewRecievers.length < 1) {
                this.generateToast("Reciever Info not saved, Please fill Required input", "error");
                this.reciever.mobile = this.reciever.mobile || undefined;
                this.reciever.email = this.reciever.email || undefined
                return false
            }
            const starttime = this.startTime ? moment(this.startTime, 'h A').format('HH:mm') : undefined;
            const endtime = this.endTime ? moment(this.endTime, 'h A').format('HH:mm') : undefined;
            let pickUpTime = starttime && endtime ? [starttime, endtime] : [];

            if ((name || contactName) && email && mobile) {
                this.$store.dispatch('setSavedNewRecievers', [...this.savedReciever, { ...this.reciever, pickUpTime }]);
                this.saveReciever();
            } else {
                this.$store.dispatch('setSavedNewRecievers', this.savedReciever);
            }
            return true
        },
        viewLocationDetails(response) {
            const addressData = {
                name: response.formatted_address,
                lat: response.geometry.location.lat(),
                lng: response.geometry.location.lng(),
                state: response?.address_components?.find(component => component.types.includes("administrative_area_level_1"))?.long_name || ""
            }
            this.reciever.address = addressData
        },
    },
}
</script>

<style lang="scss" scoped>
.type_container {
    @apply flex items-center justify-between flex-wrap w-full
}

.slice-option_address {
    @apply mt-4 w-full;
}

.plus_img {
    width: 20px
}

.img_icon {
    width: 20px
}

.img_icon_del {
    width: 15px
}

.align_top {
    vertical-align: top;
}

.table_wrapper {
    @apply min-w-[900px];
}

.add_receiver_btn {
    @apply text-primary-yellow font-semibold w-[200px] flex items-center justify-around
}

.radio-label span::after {
    @apply bg-secondary-yellow
}

.text-header {
    font-size: 24px;
    font-weight: 500;
    @apply py-4;
}

.slice-option {
    @apply mt-4 sm:mt-7 sm:w-[48%] lg:w-[32%] w-full mr-[2%] lg:mr-[1.333%];
}

.slice-option_address {
    @apply mt-4 w-full;
}

.slice-option_picker {
    @apply mt-4 sm:mt-8 sm:w-[48%] lg:w-[32%] w-full mr-[2%] lg:mr-[1.333%];
}

.input-mini {
    @apply w-full py-2 px-2 border-[1px] border-primary-palegrey rounded-md bg-primary-lightblue;
}

.slice-option_phone {
    @apply mt-4 sm:mt-6 lg:mt-6 sm:w-[48%] lg:w-[32%] w-full mr-[2%] lg:mr-[1.333%];
}

.label {
    @apply w-full block whitespace-nowrap;
}

.full_width {
    width: 100%;
    @apply bg-primary-lightgrey;
}

.icon {
    @apply w-8 cursor-pointer;
}

.google_pick_location {
    @apply mt-2 inline-flex ml-2 text-sm items-center opacity-60;

    img {
        @apply mr-1
    }
}

.image_loc {
    @apply mr-2 w-[17px] opacity-50 mt-[2px]
}

.address_grey {
    @apply opacity-50
}
</style>